/**
 * 全局常量定义
 * @author ytl
 */

// local 本地 ；server服务器；打包时，请切换到server模式
import {setSessionStorageItem} from 'components/api/utils';
import {BUSINESS_TYPE_TS} from 'components/api/interface-saas';
let appEnv = 'server';
// 商户中心接口
let interfaceMemberCenter = 'http://www.hocyun.com.cn:8889/v1';
// saas接口地址
// let interfaceSaasBase = 'http://localhost:5008/v1';
let interfaceSaasBase = 'http://www.hocyun.com.cn:9100/v1';
// saas订单接口地址
let interfaceSaasOrder = 'http://www.hocyun.com.cn:9200/v1';
// 门店端信息拉取接口
let interfaceBranchPull = 'http://www.hocyun.com.cn:7002/v1';
// 好会员接口地址
let interfaceHhy = 'https://crm.hocyun.com.cn/api-app/v1';
// 网关接口
let interfaceGateWay = 'https://api-gateway.hocyun.com.cn';
// 好会员充值地址
let memberRechargeUrl = 'https://crm.hocyun.com.cn/weixinMarketing/frontend/web/index.php/member/pay/member-recharge?';
// 成为会员地址
let memberRegUrl = 'https://crm.hocyun.com.cn/weixinMarketing/frontend/web/index.php/member/pay/member-perfect?';

/**
 * mq配置
 * host = 'XXX.mqtt.aliyuncs.com';// 设置当前用户的接入点域名，接入点获取方法请参考接入准备章节文档，先在控制台申请实例
 port = 80;//WebSocket协议服务端口，如果是走HTTPS，设置443端口
 topic = 'XXXXXXX';//需要操作的Topic
 useTLS = false;//是否走加密HTTPS，如果走HTTPS，设置为true
 accessKey = 'XXXXXX';//账号的AccessKey，在阿里云控制台查看
 secretKey = 'XXXXXX=';//账号的的SecretKey，在阿里云控制台查看
 cleansession = true;
 groupId='GID_XXXX';
 clientId=groupId+'@@@XXXX';//GroupId@@@DeviceId，由控制台申请的Group ID和自己指定的Device ID组合构成
 */
let mqttConfig = {
  host: 'mqtt-cn-4590nhpl005.mqtt.aliyuncs.com',
  port: 443,
  topic: 'hshk_common_lmq',
  useTLS: true,
  accessKey: 'LTAIfhVaJOSaDHN4',
  secretKey: 'P5qo5mh48ayPrKWG5rsgfMkDPYChDB',
  cleansession: true,
  groupId: 'GID_common_lmq'
};

// 阶梯运费
let stepFreight = {
  '5823': [
    {min: 0, max: 50, amount: 9},
    {min: 50, max: 100, amount: 6}
  ]
};

// 时间区间用券限制uid:[开始时间毫秒，结束时间毫秒]
let userCardTimeLimit = {
  '5320': [1601438399000, 1601481599000]
}

// PROSESS_ENV是由DefinePlugin定义的环境变量
if (PROSESS_ENV === 'development') {
  appEnv = 'local';
}
if (PROSESS_ENV === 'build-dev') { // 测试环境
  // 商户中心接口
  interfaceMemberCenter = 'https://d.hocyun.com.cn/api/org';
  // saas接口地址
  interfaceSaasBase = 'https://d.hocyun.com.cn/api/base';
  // saas订单接口地址
  interfaceSaasOrder = 'https://d.hocyun.com.cn/api/order';
  // 门店端信息拉取接口
  interfaceBranchPull = 'https://d.hocyun.com.cn/api/branch';
} else if (PROSESS_ENV === 'production') { // 生成环境
                                           // 商户中心接口
  interfaceMemberCenter = 'https://org.hocyun.com/v1';
  // saas接口地址
  interfaceSaasBase = 'https://base.hocyun.com/v1';
  // saas订单接口地址
  interfaceSaasOrder = 'https://order.hocyun.com/v1';
  // 门店端信息拉取接口
  interfaceBranchPull = 'https://branch.hocyun.com/v1';
  // 好会员接口地址
  interfaceHhy = 'https://crm.hocyun.com/api-app/v1';
  // 网关接口
  interfaceGateWay = 'https://api-gateway.hocyun.com';
  // 好会员充值地址
  memberRechargeUrl = 'https://crm.hocyun.com/weixinMarketing/frontend/web/index.php/member/pay/member-recharge?';
  // 成为会员地址
  memberRegUrl = 'https://crm.hocyun.com/weixinMarketing/frontend/web/index.php/member/pay/member-perfect?';
  mqttConfig = {
    host: 'mqtt-cn-4590nhpl005.mqtt.aliyuncs.com',
    port: 443,
    topic: 'hshk_common_lmq',
    useTLS: true,
    accessKey: 'LTAI4GKFRs6vrxhWf46B91NF',
    secretKey: 'rKTxp798cj9gK2sUFiSht7SXLRDkqO',
    cleansession: true,
    groupId: 'GID_common_lmq'
  };
  stepFreight = {
    '167': [
      {min: 0, max: 50, amount: 9},
      {min: 50, max: 100, amount: 6}
    ]
  };
  userCardTimeLimit = {
    '106': [1601481600000, 1602172799000]
  };
}
export function setLocalUserIdentity (_businessType) {
  let localUserIdentity = {
    businessType: _businessType || BUSINESS_TYPE_TS,
    orgId: 5823,
    uid: 5320,
    authId: 197,
    branchId: 10068,
    tableId: 0,
    tableNo: '101',
    userId: 1568344,
    showname: 'zfd',
    mobile: '17076020409',
    levelType: 'REGISTE',
    userThirdValue: 'oFlJft1R4Q_EXSh-JiNaxSbBF7zQ',
    appId: 'wx32f81502193d6653',
    isJC: 'NO'
    // menuType: 'TSEX'
    // tableName: '梦之谷',
    // entry: 'aliShopPage'   // 支付宝门店页进入
  };
  setSessionStorageItem('userIdentity', localUserIdentity);
  return localUserIdentity;
};
export const APP_ENV = appEnv;
export const INTERACE_MERCHANT_CENTER_BASE_URL = interfaceMemberCenter;
export const INTERACE_SAAS_BASE_URL = interfaceSaasBase;
export const INTERACE_SAAS_ORDER_BASE_URL = interfaceSaasOrder;
export const INTERACE_BRANCH_PULL = interfaceBranchPull;
export const INTERACE_HHY_BASE_URL = interfaceHhy;
export const INTERFACE_GATEWAY_URL = interfaceGateWay;
export const MEMBER_RECHARGE_URL = memberRechargeUrl;
export const MEMBER_REGISTE_URL = memberRegUrl;
export const MQTT_CONFIG = mqttConfig;
export const QQ_MAP = {
  app: '好易点-外送-H5',
  key: 'KYHBZ-I4YC3-7SU3J-YMC7V-DYON7-QMFBY'
};
export const STEP_FREIGHT = stepFreight;
export const USERCARD_TIME_LIMIT = userCardTimeLimit;



// WEBPACK FOOTER //
// ./src/config/params-local.js